import { attributeDefinitionIdFormat } from "@redotech/redo-ids-cockroach";

import { AttributeType, OwnerType } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createAttributeDefinition = {
  name: "createAttributeDefinition" as const,
  input: z.object({
    ownerType: createEnum(OwnerType),
    name: z.string().min(1),
    displayName: z.string().min(1),
    description: z.string().optional(),
    type: createEnum(AttributeType),
    enumValues: z.array(z.string()).optional(),
    defaultValue: z.json().optional(),
  }),

  output: z.object({
    attributeDefinitionId: attributeDefinitionIdFormat.schema,
  }),
};
